import { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setEmployeeData, updateEmployee } from "./employeeSlice";

function validEmail(email) {
  const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
    email || "",
  );
  return isValidEmail;
}
function validPhone(x) {
  const out = /^[0-9]+$/.test(x || "");
  return out;
}

const useEditEmploymentInformation = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const toastRef = useRef(null);
  const location = useLocation();
  const activeTab = location.pathname.split("/")[3] || "info";
  const { employeeDetails, isEdit, employmentInformation, isDataAvailable } =
    useSelector((state) => state.employeeregister);
  const [geninfo, setGeninfo] = useState();
  const [isSaveBtn, setIsSaveBtn] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [reset, setReset] = useState(false);
  const [isAuditSidebarVisible, setAuditSidebarVisible] = useState(false);

  useEffect(() => {
    dispatch(setEmployeeData({ key: "isEdit", value: false }));
  }, []);

  const initialdata = () => {
    let obj = {
      employee_identifier: employeeDetails?.employee_identifier || "",
      start_date: employeeDetails?.start_date || "",
      end_date: employeeDetails?.end_date,
      employment_type: employeeDetails?.employment_type,
      employment_status: employeeDetails?.employment_status,
      job_title: employeeDetails?.job_title || "",
      cost_center: employeeDetails?.cost_center || "",
      compensation_type: employeeDetails?.compensation_type,
      currency: employeeDetails?.salary_currency || "",
      salary: employeeDetails?.salary_amount || "",
    };
    return obj;
  };

  useEffect(() => {
    const obj = initialdata();
    setGeninfo(obj);
    dispatch(
      setEmployeeData({
        key: "employmentInformation",
        value: obj,
      }),
    );
  }, [employeeDetails]);

  const handleEnableEdit = () => {
    setReset(false);
    setIsUpdating(false);
    setIsSaveBtn(true);
    dispatch(
      setEmployeeData({
        key: "isEdit",
        value: true,
      }),
    );
  };

  const handleDiscardEdit = () => {
    setReset(true);
    setIsSaveBtn(false);
    const obj = initialdata();
    dispatch(
      setEmployeeData({
        key: "isEdit",
        value: false,
      }),
    );
    setGeninfo(obj);
    dispatch(
      setEmployeeData({
        key: "employmentInformation",
        value: obj,
      }),
    );
  };

  const handleChange = (name, value) => {
    setGeninfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUpdateEmploymentlInformation = () => {
    let data = {
      employee_identifier: geninfo?.employee_identifier,
      start_date: geninfo?.start_date,
      end_date: geninfo?.end_date,
      employment_type: geninfo?.employment_type,
      employment_status: geninfo?.employment_status,
      job_title: geninfo?.job_title,
      cost_center: geninfo?.cost_center,
      compensation_type: geninfo?.compensation_type,
      salary_currency: geninfo?.currency,
      salary_amount: geninfo?.salary,
    };
    setIsUpdating(true);
    dispatch(setEmployeeData({ key: "isUpdating", value: true }));
    dispatch(
      updateEmployee({ id: id, data: { ...employeeDetails, ...data } }),
    ).then(() => {
      toastRef.current.show({
        severity: "success",
        summary: "Employment Information",
        detail: "has been updated!",
        icon: "pi pi-check",
      });
      dispatch(setEmployeeData({ key: "isEdit", value: false }));
      dispatch(setEmployeeData({ key: "isUpdating", value: false }));
      dispatch(
        setEmployeeData({
          key: "employeeDetails",
          value: { ...employeeDetails, ...data },
        }),
      );
      setIsUpdating(false);
    });
  };

  useEffect(() => {
    const areObjectsEqual = (obj1 = {}, obj2 = {}) => {
      if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
      }

      return Object.keys(obj1).every((key) => obj1[key] === obj2[key]);
    };
    const isIdentical = areObjectsEqual(geninfo, employmentInformation);

    const isInfoValid =
      !!geninfo?.employee_identifier &&
      !!geninfo?.start_date &&
      !!geninfo?.employment_status &&
      !!geninfo?.salary;

    setIsSaveBtn(!isInfoValid || isIdentical);
  }, [employmentInformation, geninfo]);

  return {
    employeeDetails,
    handleEnableEdit,
    handleDiscardEdit,
    handleChange,
    reset,
    handleUpdateEmploymentlInformation,
    setAuditSidebarVisible,
    toastRef,
    genstate: {
      isDataAvailable,
      activeTab,
      isEdit,
      geninfo,
      isSaveBtn,
      isUpdating,
      isAuditSidebarVisible,
    },
  };
};

export default useEditEmploymentInformation;
